(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("axios"), require("browser-cookies"), require("lodash/cloneDeep"), require("lodash/merge"));
	else if(typeof define === 'function' && define.amd)
		define(["axios", "browser-cookies", "lodash/cloneDeep", "lodash/merge"], factory);
	else if(typeof exports === 'object')
		exports["libGetService"] = factory(require("axios"), require("browser-cookies"), require("lodash/cloneDeep"), require("lodash/merge"));
	else
		root["libGetService"] = factory(root["axios"], root["browser-cookies"], root["_"]["cloneDeep"], root["_"]["merge"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__674__, __WEBPACK_EXTERNAL_MODULE__422__, __WEBPACK_EXTERNAL_MODULE__735__, __WEBPACK_EXTERNAL_MODULE__941__) => {
return 